import * as Sentry from "@sentry/react";
import { env } from "../config/env";

let initialized = false;

/**
 * Initialize Sentry error monitoring.
 * Must be called before React renders (in main.tsx).
 */
export function initSentry(): void {
  if (initialized) return;

  const dsn = env.sentryDsn;
  if (!dsn) {
    if (env.isDev) {
      console.debug("[Sentry] No DSN configured, skipping initialization in development.");
    }
    return;
  }

  Sentry.init({
    dsn,
    environment: env.mode,
    integrations: [Sentry.browserTracingIntegration()],
    // Performance sampling — lower in production for cost
    tracesSampleRate: env.isProd ? 0.1 : 1.0,
    // Only send errors in production
    enabled: env.isProd || Boolean(dsn),
  });

  initialized = true;
}

/**
 * Capture an exception in Sentry with optional context.
 */
export function captureError(error: unknown, context?: Record<string, unknown>): void {
  if (context) {
    Sentry.withScope((scope) => {
      scope.setExtras(context);
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureException(error);
  }
}

/**
 * Sentry ErrorBoundary component for wrapping React trees.
 */
export const SentryErrorBoundary = Sentry.ErrorBoundary;

export { Sentry };
